import landingPage from "../../images/map/background-main.webp";
import phonePage from "../../images/map/map-phone.webp";
import { useState, useEffect } from "react";
import cookies from "js-cookie";
import "swiper/css";
import "swiper/css/navigation";
import commercialPin from "../../images/map/icons/business_center.webp";
import townHousePin from "../../images/map/icons/ahed-villas-white.webp";
import thurayaPin_ar from "../../images/map/icons/thuraya_ar.png";
import ahed_ar from "../../images/map/icons/ahed_ar.png";
import ahedVid_ar from "../../images/map/icons/ahed-ar-vid.png";
import thurayaVid_ar from "../../images/map/icons/thuraya-ar-vid.png";
import azha1_ar from "../../images/map/icons/azha1_ar.png";
import azha2_ar from "../../images/map/icons/azha2_ar.png";
import azha3_ar from "../../images/map/icons/azha3_ar.png";

import azha1Vid_ar from "../../images/map/icons/azha-apartment-1-ar-vid.png";
import azha2Vid_ar from "../../images/map/icons/azha-apartment-2-ar-vid.png";
import azha3Vid_ar from "../../images/map/icons/azha-apartment-3-ar-vid.png";
import thurayaPin from "../../images/map/icons/althuraya-villas-white.webp";
import townZoomIn from "../../images/map/town-zoom.webp";
import blockPin1 from "../../images/map/icons/azha-apartment-white-1.webp";
import blockPin2 from "../../images/map/icons/azha-apartment-white-2.webp";
import blockPin3 from "../../images/map/icons/azha-apartment-white-3.webp";
import block2layout from "../../images/map/block2-typical-layout-B&W.webp";
import block3layout from "../../images/map/block3-typical-layout-B&W.png";
import bedroom from "../../images/map/icons/bedroon-icon.webp";
import house from "../../images/map/icons/home-icon.webp";
import plotSize from "../../images/map/icons/plot-size-icon.png";
import gfaTotal from "../../images/map/icons/total-gfa-icon.png";
import gfa from "../../images/map/icons/gfa-icon.webp";
import plazaPin from "../../images/map/icons/plaza_pin.png";
import block4Pin from "../../images/map/icons/azha_block_4.webp";
import pin from "../../images/map/icons/pin.webp";
import plaza_ar from "../../images/map/icons/plaza_ar.png";
import azha4_ar from "../../images/map/icons/azha4_ar.png";
import business_ar from "../../images/map/icons/businessCenter_ar.png";
import axios from "axios";
import BlockComponents from "./BlockComponents.jsx";
import thurayaIn from "../../images/map/Thuraya top view.webp";
import thurayaPhone from "../../images/map/thuraya-phone-view.webp";
import blockPin1Video from "../../images/map/icons/azha-apartment-1-video.png";
import blockPin2Video from "../../images/map/icons/azha-apartment-2-video.png";
import blockPin3Video from "../../images/map/icons/azha-apartment-3-video.png";
import ahedVillaVideoPin from "../../images/map/icons/ahed-villa-video.png";
import thurayaVillaVideoPin from "../../images/map/icons/thuraya-villa-video.png";
function CommunityMap() {
  const [showTownHouses, setShowTownHouses] = useState(false);
  const [showResidential, setShowResidential] = useState(false);
  const [showVillas, setShowVillas] = useState(false);
  const [townZoom, setTownZoom] = useState(false);
  const [showBlock1, setShowBlock1] = useState(false);
  const [showBlock2, setShowBlock2] = useState(false);
  const [showBlock3, setShowBlock3] = useState(false);
  const [hoveredVilla, setHoveredVilla] = useState(null);
  const [selectedFloor, setSelectedFloor] = useState(null);
  const [floor, setFloor] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  const [error, setError] = useState(null);
  const [openPlaza, setOpenPlaza] = useState(false);
  const [openThuraya, setOpenThuraya] = useState(false);
  const [showLocations, setShowLocations] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(false);
  const [interactiveMap, setInteractiveMap] = useState([]);
  const [videoControlOption, setVideoControlOption] = useState([]);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 600);
  const [thurayaMap, setThurayaMap] = useState([]);
  const currentLanguageCode = cookies.get("i18next") || "en";
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [pdf, setPdf] = useState("");
  const getPinStyle = (isArabic, englishClasses, arabicClasses) =>
    isArabic ? arabicClasses : englishClasses;
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 600);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleGlobalClick = () => {
    if (showVillas) setShowVillas(false);
    if (showTownHouses) setShowTownHouses(false);
    if (showResidential) setShowResidential(false);
    if (townZoom) setTownZoom(false);
    if (openPlaza) setOpenPlaza(false);
    if (openThuraya) setOpenThuraya(false);
  };

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const closeModal = () => {
    setShowVideoModal(false);
    setVideoSrc("");
  };

  const pinData = [
    {
      id: 1,
      alt: "Business Center",
      onClick: () => handleImageClick(9),
      src: currentLanguageCode === "ar" ? business_ar : commercialPin,
      classes:
        currentLanguageCode === "ar"
          ? "w-[60px] right-[6%] xl:w-[50px]"
          : "w-[59px] xl:w-[50px] right-[6%] lg:left-[6%]",
      top: "top-[57%]",
    },

    {
      id: 2,
      alt: "ahed villa",
      onClick: () => handleImageClick(2),
      src: currentLanguageCode === "ar" ? ahedVid_ar : ahedVillaVideoPin,
      classes:
        currentLanguageCode === "ar"
          ? "w-[60px] left-[18%] xl:w-[50px]"
          : "w-[80px] xl:w-[60px] left-[16%]",
      top: "top-[23%]",
    },

    {
      id: 3,
      alt: "Plaza",
      onClick: () => handleImageClick(8),
      src: currentLanguageCode === "ar" ? plaza_ar : plazaPin,
      classes:
        currentLanguageCode === "ar"
          ? "w-[60px] right-[61%] xl:w-[50px]"
          : "w-[59px] xl:w-[50px] right-[61%]",
      top: "top-[35%]",
    },
    {
      id: 4,
      alt: "thuraya-villa",
      onClick: () => handleImageClick(3),
      src: currentLanguageCode === "ar" ? thurayaVid_ar : thurayaVillaVideoPin,
      classes:
        currentLanguageCode === "ar"
          ? "w-[60px] right-[63%] xl:w-[50px]"
          : "w-[80px] xl:w-[60px] right-[63%]",
      top: "top-[52%]",
    },
    {
      id: 5,
      alt: "azha-aratment-1",
      onClick: () => handleImageClick(4),
      src: currentLanguageCode === "ar" ? azha1Vid_ar : blockPin1Video,
      classes:
        currentLanguageCode === "ar"
          ? "w-[60px] left-[42%] xl:w-[50px]"
          : "w-[80px] xl:w-[60px] left-[42%] ",
      top: "top-[34%]",
    },
    {
      id: 6,
      alt: "azha-aratment-2",
      onClick: () => handleImageClick(5),
      src: currentLanguageCode === "ar" ? azha2Vid_ar : blockPin2Video,
      classes:
        currentLanguageCode === "ar"
          ? "w-[60px] left-[49%] xl:w-[50px]"
          : "w-[80px] xl:w-[60px] left-[48%]",
      top: "top-[38%]",
    },
    {
      id: 7,
      alt: "azha-aratment-3",
      onClick: () => handleImageClick(6),
      src: currentLanguageCode === "ar" ? azha3Vid_ar : blockPin3Video,
      classes:
        currentLanguageCode === "ar"
          ? "w-[60px] left-[56%] xl:w-[50px]"
          : "w-[80px] xl:w-[60px] left-[55%]",
      top: "top-[40%]",
    },
  ];

  const blocks = [
    {
      id: "block1",
      show: showBlock1,
      setShow: setShowBlock1,
      
      clickIndex: 4,
      pinClass: getPinStyle(
        currentLanguageCode === "ar",
        "w-[120px] xl:w-[100px] left-[41%] xl:left-[40%]",
        "w-[60px] left-[42%] xl:w-[50px]"
      ),
      pinSrc: currentLanguageCode === "ar" ? azha1_ar : blockPin1,
      top: "top-[35%]",
    },
    {
      id: "block2",
      show: showBlock2,
      setShow: setShowBlock2,
      layout: block2layout,
      phoneLayout: block2layout,
      clickIndex: 5,
      pinClass: getPinStyle(
        currentLanguageCode === "ar",
        "w-[120px] xl:w-[100px] xl:left-[46%] left-[47%]",
        "w-[60px] left-[49%] xl:w-[50px]"
      ),
      pinSrc: currentLanguageCode === "ar" ? azha2_ar : blockPin2,
      top: "top-[39%]",
    },
    {
      id: "block3",
      show: showBlock3,
      setShow: setShowBlock3,
      layout: block3layout,
      phoneLayout: block3layout,
      clickIndex: 6,
      pinClass: getPinStyle(
        currentLanguageCode === "ar",
        "w-[120px] xl:w-[100px] left-[55%] xl:left-[53%]",
        "w-[60px] left-[56%] xl:w-[50px]"
      ),
      pinSrc: currentLanguageCode === "ar" ? azha3_ar : blockPin3,
      top: "top-[40%]",
    },
  ];

  const handleImageClick = async (id) => {
    try {
      const response = await axios.get(
        `https://saroojdevelopment.com/laravel/public/api/video-interactive-map/${id}`
      );
      const info = response?.data;
      setPdf(info?.pdf);
      setVideoSrc(info?.video);
      setShowVideoModal(true);
    } catch (err) {
      console.error("Error fetching video:", err);
      setError("Unable to load video");
    }
  };

  const handleAzhaApartmentClicks = async (id) => {
    try {
      const response = await axios.get(
        `https://saroojdevelopment.com/laravel/public/api/azha-apartments-interactive-map/${id}`
      );
      const res = response.data.floors;

      setFloor(res);
    } catch (err) {
      console.error("Error fetching video:", err);
      setError("Unable to load video");
    }
  };
  const handleAzhaRooms = async (id) => {
    try {
      const response = await axios.get(
        `https://saroojdevelopment.com/laravel/public/api/azha-apartments-rooms/${id}`
      );
      const res = response?.data.rooms;
      setRooms(res);
      setSelectedFloor(id);
    } catch (err) {
      console.error("Error fetching video:", err);
      setError("Unable to load video");
    }
  };

  const fetchAhedVilla = async () => {
    try {
      const res = await axios.get(
        "https://saroojdevelopment.com/laravel/public/api/ahed-interactive-map-status"
      );

      setInteractiveMap(res?.data?.ahedVillas);
    } catch (error) {
      console.error("Error fetching Thuraya:", error);
    }
  };

  const fetchThurayaData = async () => {
    try {
      const res = await axios.get(
        "https://saroojdevelopment.com/laravel/public/api/thuraya-interactive-map"
      );

      setThurayaMap(res?.data?.thurayaMap);
    } catch (error) {
      console.error("Error fetching Thuraya:", error);
    }
  };

  useEffect(() => {
    const fetchVideoControl = async () => {
      const res = await axios.get(
        "https://saroojdevelopment.com/laravel/public/api/control-video-interactive-map"
      );
      const control = res.data.community.map((i) => i.interactiveMap);

      setVideoControlOption(control);
    };

    fetchVideoControl();
  }, []);

  const fetchPdf = async (link) => {
    try {
      const res = await axios.get(
        `https://saroojdevelopment.com/laravel/public/api/community-pdf/${link}`
      );
      setPdf(res?.data?.azhapdf);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  return (
    <div className="w-[100%] overflow-hidden  relative">
      <div className="  flex justify-center items-center h-[100vh]  xl:h-[85vh] lg:h-[55vh] md:h-[80vh] sm:h-[75vh] relative">
        <div
          className="absolute inset-0"
          onClick={() => {
            handleGlobalClick();
          }}
        >
          <img
            className="w-full h-[100%] md:hidden relative  "
            src={landingPage}
            alt="Sarooj landing page"
          />
          <img
            className="w-full hidden md:flex object-cover relative h-[100%]  "
            src={phonePage}
            alt="Sarooj landing page"
          />
        </div>

        {videoControlOption[0] === 1 && (
          <img
            alt=""
            onClick={() => {
              fetchAhedVilla();
              fetchPdf("ahed-villas");
              setTownZoom(true);
            }}
            src={currentLanguageCode === "ar" ? ahed_ar : townHousePin}
            className={` ${
              currentLanguageCode === "ar"
                ? "w-[60px] left-[18%] xl:w-[50px]"
                : "w-[90px] xl:w-[80px] left-[16%]"
            }  lg:hidden cursor-pointer bounce   top-[24%]   absolute`}
          />
        )}
        {videoControlOption[1] === 1 && (
          <img
            alt=""
            onClick={() => {
              fetchThurayaData();
              fetchPdf("althuraya-villas");
              setOpenThuraya(true);
            }}
            src={currentLanguageCode === "ar" ? thurayaPin_ar : thurayaPin}
            className={` ${
              currentLanguageCode === "ar"
                ? "w-[60px] right-[63%] xl:w-[50px]"
                : "w-[100px] xl:w-[80px] right-[63%]"
            }  lg:hidden cursor-pointer bounce  top-[52%]  absolute`}
          />
        )}
        {blocks.map((block, i) =>
          videoControlOption[i + 2] === 1 ? (
            <img
              key={block.id}
              onClick={() => {
                handleAzhaApartmentClicks(block.clickIndex);
                block.setShow(true);
              }}
              className={`${block.pinClass} ${block.top} cursor-pointer lg:hidden bounce absolute`}
              src={block.pinSrc}
              alt=""
            />
          ) : null
        )}

        {showVideoModal && (
          <div
            onClick={closeModal}
            className="z-[200] animate-zoom-in top-0 left-0 w-full h-full bg-[#000000bb] flex justify-center items-center"
          >
            <div className="flex flex-col justify-center items-center">
              {pdf && (
                <div className="animate-bounce w-[50%] text-end lg:w-[80%]">
                  <a
                    href={`https://saroojdevelopment.com/laravel/public/api/storage/${pdf}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-[fit-content] font-bold text-[18px] lg:text-[12px] text-white  hover:text-[gray] hover:underline cursor-pointer"
                  >
                    Download Our brochure
                  </a>
                </div>
              )}

              <div className="relative flex justify-center items-center md:min-w-[10px] min-w-[500px]">
                {error ? (
                  <div className="text-white">Error: {error}</div>
                ) : (
                  <video
                    className="relative w-[50%] lg:w-[80%]  object-cover z-0"
                    controls
                    onClick={(e) => e.stopPropagation()}
                  >
                    <source
                      src={`https://saroojdevelopment.com/laravel/public/api/storage/${videoSrc}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                )}
              </div>
            </div>
          </div>
        )}
        {blocks.map((block, i) => (
          <BlockComponents
            key={block.id}
            showBlock={block.show}
            setShowBlock={block.setShow}
            blockLayout={block.layout}
            blockPhoneLayout={block.phoneLayout}
            rooms={rooms}
            floor={floor}
            setRooms={setRooms}
            selectedUnit={selectedUnit}
            setSelectedUnit={setSelectedUnit}
            selectedFloor={selectedFloor}
            handleAhedRooms={handleAzhaRooms}
            windowWidth={windowWidth}
            blockId={block.id}
          />
        ))}
        {pinData
          .filter((pin) => {
            if (pin.id === 2 && videoControlOption[0] === 1) return false;
            if (pin.id === 4 && videoControlOption[1] === 1) return false;
            if (pin.id === 5 && videoControlOption[2] === 1) return false;
            if (pin.id === 6 && videoControlOption[3] === 1) return false;
            if (pin.id === 7 && videoControlOption[4] === 1) return false;
            return true;
          })
          .map((pin) => (
            <img
              key={pin.id}
              alt={pin.alt}
              onClick={pin.onClick}
              src={pin.src}
              className={`${pin.classes} cursor-pointer lg:hidden bounce absolute ${pin.top}`}
            />
          ))}
        <img
          alt=""
          src={currentLanguageCode === "ar" ? azha4_ar : block4Pin}
          className={` ${
            currentLanguageCode === "ar"
              ? "w-[60px] right-[34%] xl:right-[33%] xl:w-[50px]"
              : "w-[59px] xl:w-[50px] right-[34%] xl:right-[33%]"
          }   lg:hidden  bounce   top-[43%]   absolute`}
        />
        <div className="absolute hidden lg:flex justify-center items-center top-[30%] right-[0px] ">
          <div
            className={`absolute top-[30%] right-[0px] flex items-center transform transition-transform duration-500 ease-in-out ${
              showLocations ? "translate-x-0" : "translate-x-40"
            }`}
          >
            <div
              className="bg-[#202020c2] rounded-full w-[50px] bounce h-[50px] flex justify-center items-center cursor-pointer"
              onClick={() => setShowLocations(!showLocations)} // Toggle state on click
            >
              <img className="w-[25px]" src={pin} alt="pin" />
            </div>

            {/* Animated location names div */}
            <div className="bg-[#202020c2] w-[160px]  h-[150px] rounded-[10px] flex flex-col justify-evenly px-[5%] text-white text-[12px] ml-4">
              <p
                className="underline w-[fit-content]"
                onClick={() => {
                  if (videoControlOption[0] === 1) {
                    fetchAhedVilla();
                    setTownZoom(true);
                  } else {
                    handleImageClick(2);
                  }

                  fetchPdf("ahed-villas");
                }}
              >
                Ahed Villas
              </p>
              <p
                className="underline w-[fit-content]"
                onClick={() => handleImageClick(8)}
              >
                Plaza
              </p>
              <p
                className="underline w-[fit-content]"
                onClick={() => {
                  if (videoControlOption[2] === 1) {
                    handleAzhaApartmentClicks(4);
                    setShowBlock1(true);
                  } else {
                    handleImageClick(4);
                  }
                }}
              >
                Azha Apartment Block 1
              </p>
              <p
                className="underline w-[fit-content]"
                onClick={() => {
                  if (videoControlOption[3] === 1) {
                    handleAzhaApartmentClicks(5);
                    setShowBlock2(true);
                  } else {
                    handleImageClick(5);
                  }
                }}
              >
                Azha Apartment Block 2
              </p>
              <p
                className="underline w-[fit-content]"
                onClick={() => {
                  if (videoControlOption[4] === 1) {
                    handleAzhaApartmentClicks(6);
                    setShowBlock3(true);
                  } else {
                    handleImageClick(6);
                  }
                }}
              >
                Azha Apartment Block 3
              </p>
              <p
                className="underline w-[fit-content]"
                onClick={() => {
                  if (videoControlOption[1] === 1) {
                    fetchThurayaData();
                    setOpenThuraya(true);
                  } else {
                    handleImageClick(3);
                  }

                  fetchPdf("althuraya-villas");
                }}
              >
                Althuraya Villas
              </p>
              <p
                className="underline w-[fit-content]"
                onClick={() => handleImageClick(9)}
              >
                Business Center
              </p>
            </div>
          </div>
        </div>
        {townZoom && (
          <div
            onClick={() => setTownZoom(false)}
            className="h-[100%] w-[100%] flex items-center justify-center z-[100] absolute inset-0 backdrop-blur-md bg-white/30 rounded-xl border border-white/20"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="h-[100%] w-[60%] xl:w-[70%] md:h-[65%] lg:w-[70%] md:w-[90%] sm:w-[100%]  animate-zoom-in relative"
            >
              <img
                src={townZoomIn}
                alt=""
                className="h-[100%] w-[100%]  shadow-[0_4px_15px_rgba(0,0,0,0.3)]"
              />
              <a
                href={`https://saroojdevelopment.com/laravel/public/api/storage/${pdf}`}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-[3%] font-bold text-[25px] animate-bounce lg:text-[12px] md:text-[10px] right-[2%] hover:text-[#a1a1a1] text-white underline underline-offset-2"
              >
                Download our brochure!
              </a>
              {interactiveMap?.map((villa) => (
                <div
                  key={villa.id}
                  onMouseOver={() => setHoveredVilla(villa.id)}
                  onMouseLeave={() => setHoveredVilla(null)}
                  className={`text-[9px] 2xl:text-[7.5px] flex justify-center items-center flex-col text-white absolute w-[3.2vw] xl:w-[3.8vw] lg:w-[5vw] lg:h-[4.9vw] md:h-[5vw] sm:h-[7vw] h-[2.8vw] 2xl:h-[3.3vw] xl:h-[3.6vw] transform opacity-0 transition-opacity duration-300 hover:opacity-100`}
                  style={{
                    backgroundColor:
                      villa.status === "BOOKED"
                        ? "#b6b60eb0"
                        : villa.status === "SOLD"
                        ? "#ff0000c5"
                        : "#008000b9",
                    transform: `rotate(${villa.rotation})`,
                    left: villa.left,
                    top: villa.top,
                  }}
                ></div>
              ))}

              {hoveredVilla &&
                interactiveMap
                  .filter((villa) => villa.id === hoveredVilla)
                  .map((villa) => (
                    <div
                      key={villa.id}
                      className="bg-[#151515] w-[30%]  rounded-[5px] text-white flex flex-col gap-[10px] lg:gap-[5px] text-[13px] 2xl:text-[0.8vw] lg:text-[9.5px] md:text-[8.5px]  xl:text-[1vw] px-[2%] py-[1%] absolute top-[1%] lg:w-[40%] right-[1%] transition-opacity duration-300 hover:opacity-100"
                    >
                      <div className="flex justify-between">
                        <div className="leading-4"></div>
                        <p
                          className={`${
                            villa.status === "BOOKED"
                              ? "bg-[#b6b60e]"
                              : villa.status === "SOLD"
                              ? "bg-[red]"
                              : "bg-[green]"
                          } text-center h-[fit-content] text-[12px] md:text-[8px] w-[fit-content] p-[2%] rounded-[5px]`}
                        >
                          {villa.status}
                        </p>
                      </div>
                      <div className="font-[cairo] flex flex-col gap-[10px] lg:gap-[5px]">
                        <div className=" flex gap-[12px] items-center lg:gap-[5px]">
                          <img
                            className="h-[20px] w-[20px] lg:w-[15px] lg:h-[15px] md:w-[12px] md:h-[12px]"
                            src={house}
                            alt="house-icon"
                          />
                          <h2>
                            Villa #{villa.villa_number} Type {villa.typeNumber}{" "}
                            {villa.type}
                          </h2>
                        </div>
                        <div className=" flex gap-[12px] items-center lg:gap-[5px]">
                          <img
                            className="h-[25px] w-[25px] lg:w-[18px] lg:h-[18px] md:w-[15px] md:h-[15px]"
                            src={plotSize}
                            alt="house-icon"
                          />
                          <p>Plot Size {villa.plot_size_sqm} sqm</p>
                        </div>
                        <div className=" flex gap-[12px] items-center lg:gap-[5px]">
                          <img
                            className="h-[25px] w-[25px] lg:w-[18px] lg:h-[18px] md:w-[15px] md:h-[15px]"
                            src={bedroom}
                            alt="bedroom"
                          />
                          <p>{villa.number_of_rooms}</p>
                        </div>
                        <div className=" flex gap-[12px] items-center lg:gap-[5px]">
                          <img
                            className="h-[25px] w-[25px] lg:w-[18px] lg:h-[18px] md:w-[15px] md:h-[15px]"
                            src={gfa}
                            alt="gfa"
                          />
                          <p>GFA {villa.gfa_sqm} sqm</p>
                        </div>
                        <div className=" flex gap-[12px] items-center lg:gap-[5px]">
                          <img
                            className="h-[25px] w-[25px] lg:w-[18px] lg:h-[18px] md:w-[15px] md:h-[15px]"
                            src={gfaTotal}
                            alt="gfa"
                          />
                          <p>GFA Extendable to {villa.gfa_sqm_with_ph} sqm</p>
                        </div>
                      </div>
                    </div>
                  ))}
            </div>
          </div>
        )}
        {openThuraya && (
          <div
            onClick={() => setOpenThuraya(false)}
            className="h-[100%] w-[100%] flex items-center justify-center z-[100] absolute inset-0 backdrop-blur-md bg-white/30 rounded-xl border border-white/20"
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="h-[65%] w-[80%] xl:w-[90%]  md:w-[fit-content] md:h-[100%]  animate-zoom-in relative"
            >
              <img
                src={thurayaIn}
                alt=""
                className="h-[100%] md:hidden w-[100%]  shadow-[0_4px_15px_rgba(0,0,0,0.3)]"
              />
              <a
                href={`https://saroojdevelopment.com/laravel/public/api/storage/${pdf}`}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-[3%] font-bold text-[25px] animate-bounce lg:text-[12px] md:text-[10px] right-[2%] hover:text-[#a1a1a1] text-white underline underline-offset-2"
              >
                Download our brochure!
              </a>
              <img
                src={thurayaPhone}
                alt=""
                className="h-[100%] hidden w-[100%] md:flex  shadow-[0_4px_15px_rgba(0,0,0,0.3)]"
              />
              {thurayaMap.map((villa) => (
                <div
                  key={villa.id}
                  onMouseOver={() => setHoveredVilla(villa.id)}
                  onMouseLeave={() => setHoveredVilla(null)}
                  className={`text-[9px] 2xl:text-[7.5px] flex justify-center items-center flex-col text-white absolute w-[3vw] xl:w-[3.3vw] md:w-[30px] h-[5vw] xl:h-[5.8vw] transform opacity-0 transition-opacity duration-300 hover:opacity-100`}
                  style={{
                    backgroundColor:
                      villa.status === "BOOKED"
                        ? "#b6b60eb0"
                        : villa.status === "SOLD"
                        ? "#ff0000c5"
                        : "#008000b9",
                    transform: `rotate(${
                      isSmallScreen ? villa.xlrotation : villa.rotation
                    })`,
                    left: isSmallScreen ? villa.xlLeft : villa.left,
                    top: isSmallScreen ? villa.xlTop : villa.top,
                    height: isSmallScreen && villa.xlheight,
                  }}
                ></div>
              ))}

              {hoveredVilla &&
                thurayaMap
                  .filter((villa) => villa.id === hoveredVilla)
                  .map((villa) => (
                    <div
                      key={villa.id}
                      className="bg-[#151515] w-[20%] xl:w-[30%]  rounded-[5px] text-white flex flex-col gap-[10px] lg:gap-[5px] text-[13px] 2xl:text-[0.8vw] lg:text-[9.5px] md:text-[8.5px]  xl:text-[1vw] px-[2%] py-[1%] absolute top-[1%] md:w-[60%] right-[1%] transition-opacity duration-300 hover:opacity-100"
                    >
                      <div className="flex justify-between">
                        <div className="leading-4"></div>
                        <p
                          className={`text-center h-[fit-content] text-[12px] md:text-[8px] w-[fit-content] p-[2%] rounded-[5px]`}
                          style={{
                            backgroundColor:
                              villa.status === "BOOKED"
                                ? "#b6b60eb0"
                                : villa.status === "SOLD"
                                ? "#ff0000c5"
                                : "#008000b9",
                          }}
                        >
                          {villa.status}
                        </p>
                      </div>
                      <div className="font-[cairo] flex flex-col gap-[10px] lg:gap-[5px]">
                        <div className=" flex gap-[12px] items-center lg:gap-[5px]">
                          <img
                            className="h-[20px] w-[20px] lg:w-[15px] lg:h-[15px] md:w-[12px] md:h-[12px]"
                            src={house}
                            alt="house-icon"
                          />
                          <h2>{villa.thurayaName}</h2>
                        </div>
                        <div className=" flex gap-[12px] items-center lg:gap-[5px]">
                          <img
                            className="h-[25px] w-[25px] lg:w-[18px] lg:h-[18px] md:w-[15px] md:h-[15px]"
                            src={plotSize}
                            alt="house-icon"
                          />
                          <p>{villa.plotSize}</p>
                        </div>
                        <div className=" flex gap-[12px] items-center lg:gap-[5px]">
                          <img
                            className="h-[25px] w-[25px] lg:w-[18px] lg:h-[18px] md:w-[15px] md:h-[15px]"
                            src={bedroom}
                            alt="bedroom"
                          />
                          <p>{villa.bedroom}</p>
                        </div>
                        <div className=" flex gap-[12px] items-center lg:gap-[5px]">
                          <img
                            className="h-[25px] w-[25px] lg:w-[18px] lg:h-[18px] md:w-[15px] md:h-[15px]"
                            src={gfa}
                            alt="gfa"
                          />
                          <p>{villa.gfa}</p>
                        </div>
                        <div className=" flex gap-[12px] items-center lg:gap-[5px]">
                          <img
                            className="h-[25px] w-[25px] lg:w-[18px] lg:h-[18px] md:w-[15px] md:h-[15px]"
                            src={gfaTotal}
                            alt="gfa"
                          />
                          <p>{villa.gfaExtendable}</p>
                        </div>
                      </div>
                    </div>
                  ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CommunityMap;
